import { render, staticRenderFns } from "./rewards-history-row.html?vue&type=template&id=32eddcbf&scoped=true&"
import script from "./rewards-history-row.js?vue&type=script&lang=js&"
export * from "./rewards-history-row.js?vue&type=script&lang=js&"
import style0 from "./rewards-history-row.scss?vue&type=style&index=0&id=32eddcbf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eddcbf",
  null
  
)

export default component.exports